<template>
  <footer id="footer-main" class="container-fluid">
    <div class="row row-middle">
      <div class="col sm-6 col-1">
        <img :src="data.logo_1"> <img :src="data.logo_2">
      </div>
      <div class="col col-2 sm-6">
        <div v-html="data.body"></div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      data: {},
      boxStyle: {}
    }
  },

  methods: {
    load(){
      this.loading = true;
      this.$api.get('/v1/footer')
        .then(({body}) => {
          this.data = body.rows[0];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  created(){
    this.load();
  }
}
</script>

<style lang="scss">
@import '@/sass/_vars';

FOOTER
{
  border-top: 5px solid $blue-1;
  // margin-top: 45px;
  padding: 30px 0;
  overflow: hidden;

  .col-1
  {
    IMG
    {
      margin-right: 10px;
      margin-left: 10px;
    }

    @media (max-width:$screen-sm - 1)
    {
      text-align: center;
      margin-bottom: 15px;;
    }

    @media (min-width:$screen-sm)
    {
      text-align: right;
    }
  }

  .col-2
  {
    @media (min-width:$screen-xs)
    {
      line-height: 2em;
    }

    @media (max-width:$screen-xs - 1)
    {
      line-height: 1.5em;
      font-size: 11px;
    }
    
    @media (max-width:$screen-sm - 1)
    {
      text-align: center;
    }
  }
}
</style>